import Dialog from "../1. Core/Controls/Dialog/Dialog";
import Select from "../1. Core/Controls/Select/Select";
import NP from "../1. Core/NP";
import IconSelect from "../1. Core/Controls/Select/IconSelect";
import {getTournaments, ITournament} from "../10. Battle/Util";
import {EventTournament, SportType} from "../10. Battle/types";
import {ServerAPI} from "../1. Core/ServerAPI";


export default class SelectEventDialog extends Dialog {


	private _tournamentCombo: IconSelect;
	private _SportType: SportType;
	private _eventInput: Select;
	private _events: EventTournament[];


	_initFields(settings: object)
	{
		this._SportType = SportType.MMA;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('Location');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;

		this._AutoDestroy = true;
	}

	_render()
	{
		super._render();

		this._tournamentCombo = new IconSelect({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('Tournament'),
			EvItemSelected: () =>
			{
				this.updateEvents();
			}
		});


		this._eventInput = new Select({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('Event')
		});

		getTournaments(this._SportType).then((res: ITournament[]) =>
		{
			if (this._tournamentCombo)
			{
				let items = res.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name, Data: t}));
				this._tournamentCombo.addItems(items);
				this._tournamentCombo.setSelectedIndex(0, true);

				this.updateEvents();
			}
		});
	}

	async updateEvents()
	{
		let response = await ServerAPI.post("/t-events", {
			Count: 500,
			Offset: 0,
			SportType: this._SportType,
			TournamentId: this._tournamentCombo.getValue()
		}) as { List: EventTournament[], AllCount: number };

		this._events = response.List;

		this._eventInput.setItems(response.List.map(ev => ({Content: ev.Name, Value: ev.Id})));
	}


	async _onOkButtonClick()
	{
		let ev = this._events.find(ev => ev.Id == this._eventInput.getValue())
		if (ev)
			this.EvOkButtonClick.fire(this, {Event: ev});
		this.hide();
	}
}